import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, initializeRecaptchaConfig } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// EU bucket (fresh start; not the legacy us-central1 default). Override at build: REACT_APP_FIREBASE_STORAGE_BUCKET
const storageBucketId = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'svenry-73fea-eu';

// Production builds: set REACT_APP_FIREBASE_AUTH_DOMAIN=app.svenry.com (see .env.production) so Google OAuth shows your domain.
// Requires Hosting custom domain connected + https://app.svenry.com/__/auth/handler in GCP OAuth client redirect URIs.
// Dev (npm start) keeps default *.firebaseapp.com unless you override in .env.development.local.
const authDomain =
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'svenry-73fea.firebaseapp.com';

const firebaseConfig = {
    apiKey: "AIzaSyCFVqJFLrAX8ZViC7aQKYTushBIeP4DB1I",
    authDomain,
    projectId: "svenry-73fea",
    storageBucket: storageBucketId,
    messagingSenderId: "996364836753",
    appId: "1:996364836753:web:7d21e57980c56f78568430",
    measurementId: "G-33FT33T9TV"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

/** Phone Auth / SMS MFA invisible reCAPTCHA (Identity Platform). Load early so hostname keys match Console config. */
if (typeof window !== 'undefined') {
  initializeRecaptchaConfig(auth).catch((err) => {
    console.warn('Firebase Auth reCAPTCHA config:', err?.message || err);
  });
}
const storage = getStorage(app, `gs://${storageBucketId}`);

/** Returned by initializeAppCheck; used with getToken() for same-origin callable fetch. */
let appCheck;
if (typeof window !== 'undefined') {
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider('6Lfj1VEsAAAAAL8AlQpVFzc7oPYXrcK4efrQE9Hi'),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (error) {
    console.log('App Check initialization:', error.message);
  }
}

export { db, auth, app, storage, appCheck };